import React from "react"

import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell"
import FieldProto_updateView from "../../../../../proto/render/table/function/update-view"

// const debug = "FieldTimeReportTimeOfDay_TableCell"
const debug = false

export default function FieldTimeReportTimeOfDay_TableCell(props: FieldTableCellProps): React.ReactElement {
    const timeReport = props.listItem.timeReport

    const onChange = async (moment: Moment | null | undefined) => {
        (timeReport as any)[props.field.fieldId] = moment
        await timeReport.saveUniversal()
        props.listItem.updateLastUpdateTime()
        FieldProto_updateView(props.manager, props.field)
    }

    debug && console.log(debug, 'render', timeReport, props.listItem.debugName)

    return (
        <div className  = "cell-flex p-0"
             style      = {getTableCellStyle(props)}
        >
            <props.field.renderComponents.editable
                className   = "time-field ui5-txt-less-important-small w-100-percent h-100-percent p-h-10"
                disabled    = {props.manager.isReadOnly}
                field       = {props.field}
                model       = {timeReport}
                onChange    = {onChange}
            />
        </div>
    )
}
